module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_3.1ea4635a.png";